/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Template_Min_Gap_ConfirmInputs */

const en_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Template`)
};

const fr_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer le modèle`)
};

const de_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorlage erstellen`)
};

const it_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea modello`)
};

const ru_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать шаблон`)
};

const es_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear plantilla`)
};

const zh_cn2_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建模板`)
};

const ja_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テンプレートを作成`)
};

const hi_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेम्पलेट बनाएं`)
};

const pt_pt2_ad_template_min_gap_confirm = /** @type {(inputs: Ad_Template_Min_Gap_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar modelo`)
};

/**
* | output |
* | --- |
* | "Create Template" |
*
* @param {Ad_Template_Min_Gap_ConfirmInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_template_min_gap_confirm = /** @type {((inputs?: Ad_Template_Min_Gap_ConfirmInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Template_Min_Gap_ConfirmInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_template_min_gap_confirm(inputs)
	if (locale === "de") return de_ad_template_min_gap_confirm(inputs)
	if (locale === "it") return it_ad_template_min_gap_confirm(inputs)
	if (locale === "ru") return ru_ad_template_min_gap_confirm(inputs)
	if (locale === "es") return es_ad_template_min_gap_confirm(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_template_min_gap_confirm(inputs)
	if (locale === "ja") return ja_ad_template_min_gap_confirm(inputs)
	if (locale === "hi") return hi_ad_template_min_gap_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_template_min_gap_confirm(inputs)
	return en_ad_template_min_gap_confirm(inputs)
});